import React, { Component } from 'react'
import {Image, Button} from 'react-bootstrap'
import "./ArenaView.css"
import { sendNumber, sendReset } from "./api";
import io from "socket.io-client";



export default class ArenaView extends Component {
  render() {
      const socket = io('https://numbers.inspectron.ch/');
      function pReq(d) {

            fetch("https://numbers.inspectron.ch/numbers/" + d, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization:
                  "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoxLCJ1c2VybmFtZSI6ImFkbWluIn0sImlhdCI6MTU0NDUyNjExNX0.62cIOAZ6jOw9gSyUtsXYBcmHpUec8707HuhRUO7RSaM"
              }
            });
            // Socket
            sendNumber(d); 
          }
    return (
      <div className="container">
      <h1>Admin Panel</h1>
      <Button onClick={() => this.props.history.push('/admin')}>Buttons</Button>
      <Button onClick={() => this.props.history.push('/arena')}>Arena View</Button>
      <br />
      <div className="centerDiv">
          <Image src="/assets/RinkXD_v3_r.png" className="rep-img" />

          <div className="arena-point" style={{left: '-5%', top: '27%'}} onClick={() => pReq(1)}></div>
          <div className="arena-point" style={{left: '-5%', top: '22%'}} onClick={() => pReq(2)}></div>
          <div className="arena-point" style={{left: '-5%', top: '17%'}}onClick={() => pReq(3)}></div>
          <div className="arena-point" style={{left: '-5%', top: '12%'}}onClick={() => pReq(4)}></div>
          <div className="arena-point" style={{left: '-3%', top: '7%'}}onClick={() => pReq(5)}></div>
          <div className="arena-point" style={{left: '2%', top: '2%'}}onClick={() => pReq(6)}></div>
          <div className="arena-point" style={{left: '10%', top: '-1%'}}onClick={() => pReq(7)}></div>
          <div className="arena-point" style={{left: '20%', top: '-3%'}}onClick={() => pReq(8)}></div>
          <div className="arena-point" style={{left: '30%', top: '-3%'}}onClick={() => pReq(9)}></div>
          <div className="arena-point" style={{left: '41%', top: '-3%'}}onClick={() => pReq(10)}></div>
          <div className="arena-point" style={{left: '52%', top: '-3%'}}onClick={() => pReq(11)}></div>
          <div className="arena-point" style={{left: '63%', top: '-3%'}}onClick={() => pReq(12)}></div>
          <div className="arena-point" style={{left: '74%', top: '-2%'}}onClick={() => pReq(13)}></div>
          <div className="arena-point" style={{left: '83%', top: '0%'}}onClick={() => pReq(14)}></div>
          <div className="arena-point" style={{left: '89%', top: '4%'}}onClick={() => pReq(15)}></div>
          <div className="arena-point" style={{left: '93%', top: '9%'}}onClick={() => pReq(16)}></div>
          <div className="arena-point" style={{left: '94%', top: '14%'}}onClick={() => pReq(17)}></div>
          <div className="arena-point" style={{left: '94%', top: '19%'}}onClick={() => pReq(18)}></div>
          <div className="arena-point" style={{left: '94%', top: '24%'}}onClick={() => pReq(19)}></div>
          <div className="arena-point" style={{left: '94%', top: '28%'}}onClick={() => pReq(20)}></div>

          <div className="arena-point" style={{left: '-5%', top: '67%'}} onClick={() => pReq(21)}></div>
          <div className="arena-point" style={{left: '-5%', top: '72%'}} onClick={() => pReq(22)}></div>
          <div className="arena-point" style={{left: '-5%', top: '77%'}}onClick={() => pReq(23)}></div>
          <div className="arena-point" style={{left: '-5%', top: '82%'}}onClick={() => pReq(24)}></div>
          <div className="arena-point" style={{left: '-3%', top: '87%'}}onClick={() => pReq(25)}></div>
          <div className="arena-point" style={{left: '2%', top: '92%'}}onClick={() => pReq(26)}></div>
          <div className="arena-point" style={{left: '10%', top: '95%'}}onClick={() => pReq(27)}></div>
          <div className="arena-point" style={{left: '20%', top: '97%'}}onClick={() => pReq(28)}></div>
          <div className="arena-point" style={{left: '30%', top: '97%'}}onClick={() => pReq(29)}></div>
          <div className="arena-point" style={{left: '41%', top: '97%'}}onClick={() => pReq(30)}></div>
          <div className="arena-point" style={{left: '52%', top: '97%'}}onClick={() => pReq(31)}></div>
          <div className="arena-point" style={{left: '63%', top: '97%'}}onClick={() => pReq(32)}></div>
          <div className="arena-point" style={{left: '74%', top: '96%'}}onClick={() => pReq(33)}></div>
          <div className="arena-point" style={{left: '83%', top: '92%'}}onClick={() => pReq(34)}></div>
          <div className="arena-point" style={{left: '89%', top: '88%'}}onClick={() => pReq(35)}></div>
          <div className="arena-point" style={{left: '93%', top: '84%'}}onClick={() => pReq(36)}></div>
          <div className="arena-point" style={{left: '94%', top: '79%'}}onClick={() => pReq(37)}></div>
          <div className="arena-point" style={{left: '94%', top: '74%'}}onClick={() => pReq(38)}></div>
          <div className="arena-point" style={{left: '94%', top: '69%'}}onClick={() => pReq(39)}></div>
          <div className="arena-point" style={{left: '94%', top: '65%'}}onClick={() => pReq(40)}></div>

        
      </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ArenaView.jsx